import { render, staticRenderFns } from "./getwayControl.vue?vue&type=template&id=c1bf7f66&scoped=true&"
import script from "./getwayControl.vue?vue&type=script&lang=js&"
export * from "./getwayControl.vue?vue&type=script&lang=js&"
import style0 from "./getwayControl.vue?vue&type=style&index=0&id=c1bf7f66&prod&lang=scss&"
import style1 from "./getwayControl.vue?vue&type=style&index=1&id=c1bf7f66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bf7f66",
  null
  
)

export default component.exports